import React, { FC, useMemo, useRef } from 'react'

import clsx from 'clsx'
import { useHoverDirty } from 'react-use'
import styled from 'styled-components'

import { Radio } from '@style-port/roov-ui-components-react'
import { Txt } from 'src/components/atoms'

const ImgWrapper = styled.div`
  width: 20rem;
  height: 11.57rem;
  border-radius: var(--s-4);
  padding: var(--s-2);
`

const ImgCover = styled.div<{ isHovering: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${({ isHovering }) => (isHovering ? 'rgba(0, 0, 0, 0.5)' : 'none')};
  border-radius: var(--s-6);
  transition: background-color 0.1s;
`

const StyledImg = styled.img`
  border-radius: var(--s-6);
`

export const CommonContentLayoutKeys = ['gallery', 'dropdown'] as const
export type CommonContentLayoutType = typeof CommonContentLayoutKeys[number]

type Props = {
  isSelected: boolean
  layoutType: CommonContentLayoutType
  onClick?: (type: CommonContentLayoutType) => void
  className?: string
  canEdit?: boolean
}

export const CommonContentSelectLayoutItem: FC<Props> = ({
  isSelected,
  layoutType,
  onClick,
  className,
  canEdit,
}) => {
  const ref = useRef(null)
  const isHovering = useHoverDirty(ref)

  const defaultSource = useMemo(() => {
    return layoutType === 'gallery' ? '/img/image-gallery.png' : '/img/dropdown-menu.png'
  }, [layoutType])

  const hoveredSource = useMemo(() => {
    return layoutType === 'gallery' ? '/img/image-gallery-loop.gif' : '/img/dropdown-menu-loop.gif'
  }, [layoutType])

  return (
    <div className={className}>
      <div>
        <label
          htmlFor={layoutType}
          ref={ref}
          className={`${isSelected || !canEdit ? '' : 'tw-cursor-pointer'}`}
        >
          <ImgWrapper
            className={clsx(isSelected ? 'tw-bg-correctGreen-default' : 'tw-bg-border-tertiary')}
          >
            <div className="tw-relative tw-w-full tw-h-full">
              <ImgCover isHovering={isHovering} />
              <StyledImg
                src={defaultSource}
                alt=""
                className={`tw-w-full ${
                  isHovering ? 'tw-invisible tw-h-0' : 'tw-visible tw-h-full'
                }`}
              />
              <StyledImg
                src={hoveredSource}
                alt=""
                className={`tw-w-full ${
                  isHovering ? 'tw-visible tw-h-full' : 'tw-invisible tw-h-0'
                }`}
              />
            </div>
          </ImgWrapper>

          <div className="tw-centering tw-mt-s-2">
            <Radio
              nonce={undefined}
              id={layoutType}
              name="selectLayout"
              value={layoutType}
              checked={isSelected}
              onClick={() => !isSelected && canEdit && onClick && onClick(layoutType)}
            />
            <Txt className={`tw-ml-s-2 ${isSelected ? 'tw-font-bold' : ''}`}>
              {layoutType === 'gallery' ? 'スライドショー形式' : 'メニュー選択形式'}
            </Txt>
          </div>
        </label>
      </div>
    </div>
  )
}
